import type { AboTermin } from "../../hooks/useKalenderAbos";
import { OrtLink } from "./TerminTeile";

const DATUM: Intl.DateTimeFormatOptions = { weekday: "long", day: "numeric", month: "long", year: "numeric" };

function wann(t: AboTermin): string {
  const s = new Date(t.start);
  const e = new Date(t.ende);
  const tag = (d: Date) => d.toLocaleDateString("de-DE", DATUM);
  if (t.ganztags) {
    const letzter = new Date(e.getTime() - 1);
    return s.toDateString() === letzter.toDateString() ? `${tag(s)} · ganztägig` : `${tag(s)} bis ${tag(letzter)} · ganztägig`;
  }
  const uhr = (d: Date) => d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  if (e <= s) return `${tag(s)} · ${uhr(s)} Uhr`;
  if (s.toDateString() === e.toDateString()) return `${tag(s)} · ${uhr(s)}–${uhr(e)} Uhr`;
  return `${tag(s)}, ${uhr(s)} Uhr bis ${tag(e)}, ${uhr(e)} Uhr`;
}

/** Ein Termin aus einem abonnierten Kalender — über den ganzen Bildschirm, nur zum Lesen. */
export function AboTerminBlatt({ t, onClose }: { t: AboTermin; onClose: () => void }) {
  return (
    <div className="pl-overlay" onClick={onClose}>
      <div className="pl-drawer" role="dialog" aria-modal="true" aria-label={t.titel} onClick={(e) => e.stopPropagation()}>
        <div className="pl-kopf">
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 20, fontWeight: 800, overflowWrap: "anywhere" }}>{t.titel}</div>
            <div style={{ color: "var(--vg-text-3)", fontSize: 13, marginTop: 3, display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ width: 10, height: 10, borderRadius: 3, background: t.farbe, display: "inline-block" }} /> {t.kalender}{t.von_wem ? ` · ${t.von_wem}` : ""}
            </div>
          </div>
          <button type="button" onClick={onClose} className="pl-closebtn" aria-label="Schließen">×</button>
        </div>
        <div className="pl-abo-blatt">
          <div className="pl-abo-zeile"><span>Wann</span><span>{wann(t)}</span></div>
          {t.ort && <div className="pl-abo-zeile"><span>Ort</span><OrtLink ort={t.ort} /></div>}
          {t.beschreibung && <div className="pl-abo-zeile"><span>Notiz</span><span className="pl-abo-text">{t.beschreibung}</span></div>}
          <p className="pl-tag-hinweis">{t.von_wem ? `Aus einem Kalender, den ${t.von_wem} freigegeben hat — nur zum Lesen.` : "Aus deinem abonnierten Kalender — ändern kannst du ihn nur dort (z. B. in Apple Kalender)."}</p>
        </div>
      </div>
    </div>
  );
}
